import { CollapseGroup, LoadingFit, MenuFooter } from '../../share/Components'
import RecordPatientComplaint from './Items/RecordPatientComplaint'
import RecordEssentialInformation from './Items/RecordEssentialInformation'
import RecordPen from './Items/RecordPen'
import RecordSummary from './Items/RecordSummary'
import RecordDiagnosis from './Items/RecordDiagnosis'
import RecordCheckup from './Items/RecordCheckup'
import RecordActions from './Items/RecordActions'
import RecordAttachment from './Items/RecordAttachment'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { Button, Icon, TextBox } from '../../share/Elements'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { useEffect, useState } from 'react'
import { RecordCatalogViewModel } from '../../models/ViewModels/RecordCatalogViewModel'
import RecordLaboratoryResult from './Items/RecordLaboratoryResult'
import RecordInfertility from './Items/RecordInfertility'
import RecordFertility from './Items/RecordFertility'
import { toast } from 'react-toastify'
import {
  RecordAttachItem,
  RecordViewModel,
} from '../../models/ViewModels/RecordViewModel'
import HelTag from 'react-helmet'
import { CollapseInterface } from '../../Interfaces/CollapseInterface'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import RecordHistory from './Items/RecordHistory'
import {
  ListPenImageInterface,
  PenImageInterface,
} from '../../Interfaces/ListPenImageInterface'
import {
  clearData,
  insertPenFile,
  insertPenImg,
} from '../../storeManager/Reducers/penImageSlice'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'

const Record = ({
  patientCode,
  ticketId,
}: {
  patientCode: string
  ticketId: string
}) => {
  const dispatch = useDispatch()
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const [isLoading, setIsLoading] = useState(true)

  const startTimer = () => {
    // Set a timer for 10 seconds
    const timerId = setTimeout(() => {
      // Timer has elapsed, update state to stop loading
      setIsLoading(false)
    }, 4000) // 10 seconds in milliseconds

    // Clear the timer if needed
    // return () => clearTimeout(timerId);
  }
  const [recordData, setRecordData] = useState<RecordViewModel>({})
  const recordItems = useFetch<
    RecordViewModel,
    unknown,
    { ticketId: string }
  >({
    request: RaytebRequests.Profile_Profile_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setIsLoading(true)
      data.patientCode = patientCode
      setRecordData(data)
      console.log('get pen file')
      dispatch(insertPenFile({ recordId: data.id, penFile: data.pen?.file, penBase64: data.pen?.base64 }))
      startTimer()
    },
    onStatusCode400(data) {
      startTimer()
    },
  })
  const [catalogData, setCaltalogData] = useState<RecordCatalogViewModel>({})
  const catalogItems = useFetch<RecordCatalogViewModel>({
    request: RaytebRequests.Profile_Cataloges_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setCaltalogData(data)
      recordSummary.reFetch(null, {
        patientCode: patientCode,
      })
    },
  })
  const { reFetch } = useFetch<RecordViewModel>({
    request: RaytebRequests.Profile_Profile_POST({
      token: user.token,
      headers: { centerId: center.id },
    }),
    onSuccess(data) {
      toast.success('پرونده با موفقیت ثبت شد')
      setRecordData({})
      recordItems.reFetch(null, {
        ticketId: ticketId,
      })
      recordSummary.reFetch(null, {
        patientCode: patientCode,
      })
    },
  })
  const [penImg, setPenImg] = useState<string>()
  const penFile = useFetch<string>({
    request: RaytebRequests.Profile_SavePen_POST({
      token: user.token,
    }),
    onSuccess(data) {
      setRecordData({
        ...recordData,
        pen: { ...recordData.pen, file: data },
      })
      reFetch({ ...recordData, pen: { ...recordData.pen, file: data } })
    },
  })

  const [recordSummaryData, setRecordSummaryData] =
    useState<RecordSummaryViewModel>({})
  const recordSummary = useFetch<
    RecordSummaryViewModel,
    unknown,
    { patientCode: string }
  >({
    request: RaytebRequests.Profile_GetSummary_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setRecordSummaryData(data)
    },
  })

  const handleFertilityChange = (updatedItem) => {
    setRecordData({ ...recordData, fertility: updatedItem })
  }
  const handleInfertilityChange = (updatedItem) => {
    setRecordData({ ...recordData, infertility: updatedItem })
  }
  const handleLaboratoryResultChange = (updatedItem) => {
    setRecordData({ ...recordData, laboratoryResult: updatedItem })
  }
  const handleEssentialChange = (updatedItem) => {
    setRecordData({
      ...recordData,
      essentialEnformation: updatedItem,
    })
  }
  const handlePenChange = (updateItem) => {
    if (!updateItem) {
      const newPen = { ...recordData.pen }
      newPen.base64 = undefined
      newPen.file = undefined
      setRecordData({ ...recordData, pen: newPen })
    }
    setPenImg(updateItem)
    console.log('change pen', { recordId: recordData.id, penImg: updateItem })
    dispatch(insertPenImg({ recordId: recordData.id, penImg: updateItem }))
  }
  const handleCheckupChange = (updatedItem) => {
    setRecordData({ ...recordData, checkup: updatedItem })
  }
  const handleHistoryChange = (updatedItem) => {
    setRecordData(updatedItem)
  }
  const handleAttachChange = (updatedItem) => {
    setRecordData({ ...recordData, attach: updatedItem })
  }
  const handlePatientComplaintChange = (updatedItem) => {
    setRecordData({ ...recordData, complaint: updatedItem })
  }
  const handleDiagnosisChange = (updatedItem) => {
    setRecordData({ ...recordData, diagnosis: updatedItem })
  }
  const handleActionChange = (updatedItem) => {
    setRecordData({ ...recordData, action: updatedItem })
  }
  const arr: Array<CollapseInterface> = [
    {
      icon: 'rayteb-warning',
      className: {
        iconClass: '!text-3xl !text-warn ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      title: recordData.essentialEnformation?.caption, // "اطلاعات ضروری",
      isShow: recordData.essentialEnformation?.isShow!,
      openDefault: true,
      element: (
        <RecordEssentialInformation
          item={recordData.essentialEnformation}
          onItemChange={handleEssentialChange}
        />
      ),
    },
    {
      icon: 'rayteb-rx',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      title: recordData.abstract?.caption, // "خلاصه پرونده",
      isShow: recordData.abstract?.isShow!,
      element: <RecordSummary data={recordSummaryData} />,
    },
    {
      icon: 'rayteb-online-visit',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.pen?.isShow!,
      title: recordData.pen?.caption, // "قلم نوری",
      openDefault: true,
      element: (
        <RecordPen
          item={recordData.pen}
          recordId={recordData.id}
          onItemChange={handlePenChange}
        />
      ),
    },
    {
      icon: 'rayteb-users-1',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.complaint?.isShow!,
      title: recordData.complaint?.caption, // "شکایت بیمار",
      element: (
        <RecordPatientComplaint
          catalogs={catalogData.symptomType}
          item={recordData.complaint}
          onItemChange={handlePatientComplaintChange}
        />
      ),
    },
    {
      icon: 'rayteb-medical-doctor',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.diagnosis?.isShow!,
      title: recordData.diagnosis?.caption, // "تشخیص",
      element: (
        <RecordDiagnosis
          sevirity={catalogData.severity}
          diagnosisStatus={catalogData.diagnosisStatus}
          item={recordData.diagnosis}
          onItemChange={handleDiagnosisChange}
        />
      ),
    },
    {
      icon: 'rayteb-medical-inpatient',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.checkup?.isShow!,
      title: recordData.checkup?.caption, // "معاینه",
      element: (
        <RecordCheckup
          catalog={catalogData.measureItem}
          item={recordData.checkup}
          onItemChange={handleCheckupChange}
        />
      ),
    },
    {
      icon: 'rayteb-terms-conditions',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.action?.isShow!,
      title: recordData.action?.caption, // "اقدامات",
      element: (
        <RecordActions
          catalog={catalogData.actionTimeDuration!}
          item={recordData.action}
          onItemChange={handleActionChange}
        />
      ),
    },
    {
      icon: 'rayteb-rx',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      title: recordData.history?.caption, // "سوابق پزشکی",
      isShow: recordData.history?.isShow!,
      element: (
        <RecordHistory
          catalog={catalogData}
          record={recordData}
          onItemChange={handleHistoryChange}
        />
      ),
    },
    {
      icon: 'rayteb-medical-clinical',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.fertility?.isShow!,
      title: recordData.fertility?.caption, // "باروری",
      element: (
        <RecordFertility
          catalogs={catalogData.fertility}
          item={recordData.fertility}
          onItemChange={handleFertilityChange}
        />
      ),
    },
    {
      icon: 'rayteb-medical-clinical',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.infertility?.isShow!,
      title: recordData.infertility?.caption, // "ناباروری",
      element: (
        <RecordInfertility
          catalog={catalogData.infertility}
          item={recordData.infertility!}
          onItemChange={handleInfertilityChange}
        />
      ),
    },
    {
      icon: 'rayteb-medical-clinical',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.laboratoryResult?.isShow!,
      title: recordData.laboratoryResult?.caption, // "آزمایشات",
      element: (
        <RecordLaboratoryResult
          catalogs={catalogData.laboratoryResult}
          item={recordData.laboratoryResult!}
          onItemChange={handleLaboratoryResultChange}
        />
      ),
    },
    {
      icon: 'rayteb-file',
      className: {
        iconClass: '!text-3xl !text-disable ',
        titleClass: '!font-bold !text-sm !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 ',
      },
      isShow: recordData.attach?.isShow!,
      title: recordData.attach?.caption, // "پیوست فایل",
      element: (
        <RecordAttachment
          item={recordData.attach!}
          onItemChange={handleAttachChange}
        />
      ),
    },
  ]

  useEffect(() => {
    recordItems.reFetch(null, {
      ticketId: ticketId,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    catalogItems.reFetch()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <HelTag>
        <title>پرونده</title>
      </HelTag>

      <div className='pb-20'>
        <LoadingFit isLoading={isLoading} />
        {recordItems.isLoading || catalogItems.isLoading ? (
          <SkeletonTheme>
            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>

            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>

            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>
            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>
            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>
          </SkeletonTheme>
        ) : (
          <>
            <div className='flex justify-between mx-4 mt-5 mb-5 border-b border-y-primaryLight'>
              <span>نمایش کل پرونده:</span>
              <Icon
                icon='rayteb-printer  !text-xl text-primaryLight cruser-pointer'
                onClick={() => {
                  window.open(
                    `${window.env['APP_Domain']}/api/DoctorProfile/Patient/GetAllProfiles?doctorCode=${user.userData?.code}&centerId=${center.id}&patientCode=${patientCode}`
                  )
                }}
                className='text-xl text-primary'
              />
            </div>
            <CollapseGroup items={arr} />
            <TextBox
              innerText='توضیحات'
              className='w-full mt-2'
              Type={TextBoxTypeEnum.Text}
              value={recordData.description}
              debounceTime={0}
              onChange={(e) =>
                setRecordData({ ...recordData, description: e.target.value })
              }
            />
          </>
        )}
      </div>
      <MenuFooter>
        <Button
          onClick={(e) => {
            startTimer()

            if (penImg) {
              penFile.reFetch({
                id: recordData.id!,
                pen: penImg!,
              })
            } else reFetch(recordData)
          }}
          className='h-10 w-full  bg-secondary md:mx-auto md:w-96 text-white mx-2'
        >
          ثبت پرونده
        </Button>
      </MenuFooter>
    </>
  )
}

export default Record
